import { walkMinutes } from "../../shared/route-trace.ts";
import { t } from "../i18n/index.ts";

export function formatMinutes(minutes: number): string {
  if (minutes < 60) return t("eta.minutes", { count: minutes });
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? t("eta.hoursMinutes", { hours, minutes: rest }) : t("eta.hours", { count: hours });
}

/** Estimated walking time for a route, e.g. "~45 min". */
export function walkLabel(lengthM: number): string {
  return `~${formatMinutes(walkMinutes(lengthM))}`;
}

/** The start/finish and time limit strip, e.g. "Fixed start & finish · 30 min limit". */
export function questSettingsSummary(q: { start_fixed?: boolean; time_limit_s?: number | null }): string {
  const parts = [t(q.start_fixed ? "rt.strip.fixed" : "rt.strip.anywhere")];
  const limit = q.time_limit_s;
  parts.push(limit ? t("rt.strip.limit", { count: Math.round(limit / 60) }) : t("rt.strip.noLimit"));
  return parts.join(" · ");
}
